import { VersionSelectorModal } from './version-selector-modal';
export default VersionSelectorModal;
